import React from "react";
import { Link } from "react-router-dom";
import PlaywrightTemplate from "./PlaywrightTemplate";
import styles from "../../styles/Playwrightpages.module.css";

const PwNavigation = () => {
  const sections = [
    {
      heading: "",
      ui: (
        <div className={styles.navWrapper}>
          
          {/* GO TO HOMEPAGE */}
          <div className={styles.navBlock}>
            <h3>GO TO HOMEPAGE</h3>
            <Link to="/" className={styles.blueLink}>
              HOMEPAGE
            </Link>
          </div>

          {/* FIND ME */}
          <div className={styles.navBlock}>
            <h3>FIND WHERE I AM SUPPOSED TO GO WITHOUT CLICKING ME</h3>
            <a
              href="https://bsparksoftwaretechnologies.com/courses/playwright-test-automation"
              className={styles.pinkLink}
            >
              FIND ME
            </a>
          </div>

        </div>
      ),
      code: `// Click homepage
await page.getByRole('link', { name: 'HOMEPAGE' }).first().click();

// Find where link points without clicking
const url = await page.getByText('FIND ME').getAttribute('href');`
    }
  ];

  return <PlaywrightTemplate title="🔗 Navigation" sections={sections} />;
};

export default PwNavigation;